import { createEntityAdapter, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { selectActiveAnimalById } from "../../../Store/ActiveStateHandlers/activeAnimalSlice";
import { SystemLimitations } from "./GQLCalls/systemLimitations";
import { RootState } from "../../../Store";

export const systemLimitationsDataAdapter = createEntityAdapter({
  selectId: (item: SystemLimitations) => item.fk_system_types
});

export const systemLimitationsSlice = createSlice({
  name: "systemLimitations",
  initialState: systemLimitationsDataAdapter.getInitialState({loading: "idle"}),
  reducers: {
    addSystemLimitations: (state, {payload}: PayloadAction<SystemLimitations[]>) => {
      state.loading = "false";
      systemLimitationsDataAdapter.addMany(state, payload);
    },
    updateSystemLimitation: systemLimitationsDataAdapter.updateOne,
    upsertSystemLimitations: systemLimitationsDataAdapter.upsertMany,
    clearSystemLimitations: systemLimitationsDataAdapter.removeAll,
  }
})

export const { addSystemLimitations, upsertSystemLimitations, clearSystemLimitations } = systemLimitationsSlice.actions;
export const { selectById: selectSystemLimitationBySystemType, selectAll: selectAllSystemLimitations } = systemLimitationsDataAdapter.getSelectors((state: RootState) => state.graphQlData.systemLimitations);